import * as mapboxgl from 'mapbox-gl';
import MapboxDraw from '@mapbox/mapbox-gl-draw';
import { DRAW_STYLES } from './map-draw.styles';

export function createEditorMap(
  accessToken: string,
  container: HTMLElement,
  center: mapboxgl.LngLatLike
): mapboxgl.Map {
  return new mapboxgl.Map({
    accessToken,
    container,
    style: 'mapbox://styles/mapbox/satellite-streets-v12',
    zoom: 6,
    center,
    // Off (Mapbox's own default): cooperative gestures only exist to stop a map from
    // hijacking the scroll of the page behind it. This dialog is full-screen (100vw/vh,
    // CDK overlay blocks the body scroll), so there is nothing behind it to protect --
    // it would only force "hold CMD to zoom" on every wheel tick. The read-only
    // common/map-view-dialog.component.ts sets it false for the same reason.
    cooperativeGestures: false,
    dragRotate: true,
    dragPan: true,
  });
}

export function createEditorDraw(): MapboxDraw {
  const baseModes: any = (MapboxDraw as any).modes || {};
  const NoDragDirectSelect = { ...baseModes.direct_select, dragFeature() {} };
  return new MapboxDraw({
    displayControlsDefault: false,
    controls: { polygon: false, trash: false },
    defaultMode: 'simple_select',
    styles: DRAW_STYLES,
    modes: { ...baseModes, direct_select: NoDragDirectSelect },
  });
}
